module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.field_list), function(field, index) {
    return [(_vm.repeatField(field.rules)) ? [_c('transition-group', {
      attrs: {
        "name": "fade"
      }
    }, _vm._l((_vm.repeatField(field.rules)), function(n) {
      return (_vm.showField(field.rules)) ? _c('form-item', {
        key: n,
        attrs: {
          "type": field.type,
          "name": field.name,
          "title": field.title,
          "data": field.data,
          "repeat": true
        },
        model: {
          value: (_vm.field_list[index].value),
          callback: function($$v) {
            _vm.$set(_vm.field_list[index], "value", $$v)
          },
          expression: "field_list[index].value"
        }
      }) : _vm._e()
    }))] : [_c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [(_vm.showField(field.rules)) ? _c('form-item', {
      attrs: {
        "type": field.type,
        "name": field.name,
        "title": field.title,
        "data": field.data
      },
      model: {
        value: (_vm.field_list[index].value),
        callback: function($$v) {
          _vm.$set(_vm.field_list[index], "value", $$v)
        },
        expression: "field_list[index].value"
      }
    }) : _vm._e()], 1)]]
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.field_errors.length > 0),
      expression: "field_errors.length > 0"
    }],
    staticClass: "error-container"
  }, _vm._l((_vm.field_errors), function(field) {
    return _c('p', {
      staticClass: "error"
    }, [_vm._v(_vm._s(_vm.$t('form.error_blank', {
      field: field.title
    })))])
  }))], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-758689ca!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/FormList.vue
// module id = 266
// module chunks = 1